import 'css/src/components/public-pages/Page404';

import React from 'react';

const PageTermsVideoblocks = React.memo(function PageTermsVideoblocks() {
    return (
        <section style={{ marginTop: '140px' }}>
            <div className="container">
                <div className="page" title="Page 2">
                    <div className="section">
                        <div className="layoutArea">
                            <div className="column">
                                <h3 className="mt-l5-48">End User License Agreement</h3>
                                <br />
                                <div className="font-l5 font-l5--regular">
                                    A. Your Rights. We (Footage Firm, Inc., the operator of
                                    storyblocks.com, videoblocks.com, graphicstock.com, and
                                    audioblocks.com) grant you a perpetual, worldwide, limited,
                                    non-exclusive, non-transferable right to incorporate the Stock
                                    Files you obtain from us into a work you create. You may
                                    incorporate our Stock Files into any project, including feature
                                    films, broadcast, commercial, educational, print, multimedia,
                                    games, merchandise, and the internet. Once you incorporate a
                                    Stock File into your project, you can share your finished
                                    project freely, but you may not share the underlying individual
                                    Stock File as a standalone file with a third party. (However,
                                    you can share the Stock Files with your client or other third
                                    party for the limited purpose of getting their help with your
                                    specific project, assuming you are adding substantial value to
                                    the project apart from the Stock Files. Otherwise, they need
                                    their own license.) You also agree to use your best efforts to
                                    secure the Stock File from being accessed by a third party as a
                                    standalone file, but since that&rsquo;s not always possible,
                                    your inability to prevent copying will not be considered a
                                    breach of this License.
                                </div>
                                <br />
                                <div className="font-l5 font-l5--regular">
                                    B. Our Guarantee. We promise that if you use our Stock Files as
                                    described in this License, your use will not infringe on the
                                    rights (such as copyrights) of a third party (the &ldquo;Limited
                                    Warranty&rdquo;). We&rsquo;ll also put our money where our mouth
                                    is. In fact, we will provide you up to $20,000 in
                                    indemnification if you incur any direct damages from our
                                    breaking this promise. Because that&rsquo;s a big number, we
                                    need to make a few things clear, so here come some capital
                                    letters. IN NO EVENT, INCLUDING NEGLIGENCE, SHALL WE BE LIABLE
                                    TO YOU OR ANY THIRD PARTY FOR INCIDENTAL, INDIRECT, OR
                                    CONSEQUENTIAL DAMAGES OF ANY KIND. OUR MAXIMUM AGGREGATE
                                    LIABILITY FOR ALL BREACHES OF THE LIMITED WARRANTY WILL BE
                                    LIMITED TO THE LESSER OF THE ACTUAL, DIRECT DAMAGES SUFFERED BY
                                    YOU DIRECTLY ARISING FROM SUCH BREACH AND TWENTY THOUSAND
                                    DOLLARS.
                                </div>
                                <br />
                                <div className="font-l5 font-l5--regular">
                                    Note that trademarks, logos, or copyrights depicted within our
                                    Stock Files are not covered by this guarantee. For example, if
                                    one of our videos depicts someone holding a brand-name beverage,
                                    that label may be protected by copyright and trademark law and
                                    should be used at your own risk. (We wouldn&rsquo;t want you to
                                    think that this License lets you reprint Coca-Cola cans.)
                                </div>
                                <br />
                                <div className="font-l5 font-l5--regular">
                                    C. Limitations. There are a few other limitations we have put in
                                    place to protect our artists and other customers:
                                </div>
                                <ol>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            You cannot sell, license, or redistribute our Stock
                                            Files, nor can you build your own stock media site with
                                            our files.
                                        </div>
                                        <div className="font-l5 font-l5--regular">
                                            You cannot create a trademark or logo based on our Stock
                                            Files. You cannot use automation, such as computer
                                            scripts, to download or &ldquo;scrape&rdquo; high
                                            volumes of our Stock Files. Finally, you cannot use the
                                            Stock Files to harm minors, to encourage violence, or
                                            for an unlawful purpose, such as defamation.
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            For Stock Files that depict identifiable people
                                            (&ldquo;Models&rdquo;), you must not depict the Models
                                            in a way that a reasonable person would find offensive.
                                            Just to be clear, the issue is whether the depiction of
                                            the Models themselves is offensive, not whether your
                                            project as a whole may be offensive. For example, you
                                            could use Stock Files with Models in a documentary about
                                            a rare and embarrassing medical condition, but you
                                            should not depict the Models in a way that suggests they
                                            personally carry the condition, unless our video clip
                                            already depicts them that way.
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            For our audio Stock Files, your license does not
                                            restrict your right of public performance, but a cue
                                            sheet may be required to satisfy the requirements of
                                            Performance Rights Organizations (&ldquo;PROs&rdquo;).
                                            Also, this License allowed you to use our audio clips in
                                            YouTube videos, but since we are not associated with
                                            YouTube, we cannot prevent other people from incorrectly
                                            claiming that your video violates a copyright. If you
                                            get such a claim, let us know, and we will make our best
                                            efforts to help you resolve the problem. Still,
                                            platforms like YouTube could block your content for
                                            reasons beyond our control.
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            Some Stock Files may have additional restrictions, such
                                            as &ldquo;editorial use only,&rdquo; which will be noted
                                            in the clip&rsquo;s details.
                                        </div>
                                    </li>
                                </ol>
                                <div className="font-l5 font-l5--regular">
                                    D. Other Legal Provisions. This part may not be fun to read, but
                                    it&rsquo;s important nevertheless.
                                </div>
                                <ol>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            This Agreement will be governed by the laws of the State
                                            of Delaware, excluding its body of law relating to
                                            conflicts of
                                        </div>
                                        <div className="font-l5 font-l5--regular">
                                            law and copyright law. If any provision of this
                                            Agreement is found invalid, the other provisions will
                                            not be affected.
                                        </div>
                                    </li>
                                    <li>
                                        <div className="font-l5 font-l5--regular">
                                            Except for claims brought in small claims court, all
                                            disputes about this Agreement will be settled by
                                            arbitration pursuant to
                                        </div>
                                        <div
                                            className="font-l5 font-l5--regular"
                                            style={{ marginBottom: '100px' }}
                                        >
                                            the rules of the American Arbitration Association
                                            (&ldquo;AAA&rdquo;), subject to the Federal Arbitration
                                            Act. The dispute may be arbitrated either by JAMS or
                                            AAA. You are thus GIVING UP YOUR RIGHT TO GO TO COURT to
                                            assert or defend your rights EXCEPT for matters that may
                                            be taken to small claims court. Your rights will be
                                            determined by a NEUTRAL ARBITRATOR and NOT a judge or
                                            jury. You are entitled to a FAIR HEARING, BUT the
                                            arbitration procedures are SIMPLER AND MORE LIMITED THAN
                                            RULES APPLICABLE IN COURT. Arbitrator decisions are as
                                            enforceable as any court order and are subject to VERY
                                            LIMITED REVIEW BY A COURT.
                                        </div>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});

export default PageTermsVideoblocks;
